import { render, staticRenderFns } from "./EditorEasyMDE.vue?vue&type=template&id=87b2ddd0"
import script from "./EditorEasyMDE.vue?vue&type=script&lang=js"
export * from "./EditorEasyMDE.vue?vue&type=script&lang=js"
import style0 from "./EditorEasyMDE.vue?vue&type=style&index=0&id=87b2ddd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports